import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AddUrlDialogComponent } from '@dialogs/add-url/add-url-dialog.component';
import { DropboxDialogComponent } from '@dialogs/dropbox-dialog/dropbox-dialog.component';
import { SharepointDialogComponent } from '@dialogs/sharepoint-dialog/sharepoint-dialog.component';
import { map, tap } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { DataSourceApiService } from './data-source-api.service';

@Injectable({ providedIn: 'root' })
export class DataSourceUrlService {
  private dialog = inject(MatDialog);
  private authService = inject(AuthService);
  private dataSourceApiService = inject(DataSourceApiService);

  generateUrlFromDataSource(params: any) {
    let { field, formValue, connectedAppStatus, dropboxConnect, sharepointConnect } = params;
    localStorage.setItem('formschemaModelData', JSON.stringify(formValue));
    if (formValue.datasource === 'url') {
      const dialogRef = this.dialog.open(AddUrlDialogComponent, {
        height: 'auto',
        panelClass: 'inline-schema',
        data: {
          url: formValue.url
        }
      });
      return dialogRef.afterClosed().pipe(map((result) => result.value.url));
    }
    this.dataSourceApiService.getConnectedAppsStatus().subscribe((res: any) => {
      connectedAppStatus = [];
      Object.entries(res).forEach(([key, value]) => {
        if (key === 'dropbox' || key === 'sharepoint') {
          connectedAppStatus.push({
            appname: key,
            button: value ? 'disconnect' : 'connect',
            icon: `/assets/icons/svg-imports/${key}.svg`
          });
          if (key === 'dropbox' && value) {
            dropboxConnect = true;
          } else if (key === 'sharepoint' && value) {
            sharepointConnect = true;
          }
        }
      });

      if (formValue.datasource === 'dropbox') {
        if (dropboxConnect === true) {
          const dialogRef = this.dialog.open(DropboxDialogComponent, {
            panelClass: 'dropbox-sharepoint',
            data: {
              url: formValue
            }
          });

          return dialogRef.afterClosed().pipe(
            tap(() => {
              localStorage.removeItem('Authonticating_from_page');
              localStorage.removeItem('dropboxOrsharepointDialogOpen');
            })
          );
        }
        // we are getting through this api drop-box auth url for backend
        // api - auth/dropbox/login

        const baseUrlOfSite = window.location.hostname;
        let callbackUrl = '';
        if (baseUrlOfSite === 'localhost') {
          callbackUrl = 'https://new-dev.makersite.app/dropbox-authorization.html';
        } else {
          callbackUrl = `https://${baseUrlOfSite}/dropbox-authorization.html`;
        }
        localStorage.setItem('dropbox_to_callbackUrl', callbackUrl);

        // set api server url
        localStorage.setItem('dropbox_to_makersite_api_SERVER_URL', '');

        // set browser page url in local storage
        localStorage.setItem('dropbox_to_makersite_page_url', window.location.href);
        localStorage.setItem('dropbox_or_sharepoint_from_importer', 'datasoure');

        // when we are authenticating from data source
        localStorage.setItem('Authonticating_from_page', 'data-sources');
        // storing meta data

        localStorage.setItem('dropboxOrsharepointDialogOpen', 'open');

        // set auth token for dropbox in local storage
        localStorage.setItem('dropbox_to_api_token', `Bearer ${this.authService.getToken()}`);
        window.location.href = `/api/v1/auth/dropbox/login?callback=${callbackUrl}`;
      } else if (formValue.datasource === 'sharepoint') {
        if (sharepointConnect === true) {
          const dialogRef = this.dialog.open(SharepointDialogComponent, {
            panelClass: 'dropbox-sharepoint',
            data: {
              url: formValue
            }
          });

          return dialogRef.afterClosed().pipe(
            tap(() => {
              localStorage.removeItem('Authonticating_from_page');
              localStorage.removeItem('dropboxOrsharepointDialogOpen');
            })
          );
        }
        const baseUrlOfSite = window.location.hostname;
        let callbackUrl = '';
        if (baseUrlOfSite === 'localhost') {
          callbackUrl = `http://${window.location.host}/sharepoint-authorization.html`;
        } else {
          callbackUrl = `https://${baseUrlOfSite}/sharepoint-authorization.html`;
        }
        localStorage.setItem('sharePoint_to_callbackUrl', callbackUrl);

        localStorage.setItem('dropbox_to_api_token', `Bearer ${this.authService.getToken()}`);
        // set api server url
        localStorage.setItem('dropbox_to_makersite_api_SERVER_URL', '');

        // set browser page url in local storage
        localStorage.setItem('dropbox_to_makersite_page_url', window.location.href);

        localStorage.setItem('dropbox_or_sharepoint_from_importer', 'datasoure');
        localStorage.setItem('dropboxOrsharepointDialogOpen', 'open');

        // when we are authenticating from data source
        localStorage.setItem('Authonticating_from_page', 'data-sources');

        this.dataSourceApiService.getShareAuthenticationUrl(callbackUrl).subscribe((res: any) => {
          window.location.href = res.auth_url;
        });
      }
    });
  }
}
